import { BlogSection } from '@/types/blog';

export const praxis: BlogSection = {
  id: 'praxis',
  title: 'Katalysator-Führung in der Praxis',
  content: `
<p class="mb-4 text-lg font-medium">
  Wie sieht das konkret aus?
</p>

<div class="bg-joerg-50 p-6 rounded-xl border border-joerg-200 my-6">
  <p class="mb-3">
    <strong>Montagmorgen, 9 Uhr.</strong> Die Projektleiterin sagt: "Das Konzept funktioniert nicht. Marketing und IT reden aneinander vorbei."
  </p>
  <p class="mb-3">
    Die klassische Führungskraft fragt: "Woran liegt das?" und sucht den Schuldigen.
  </p>
  <p class="text-primary font-medium">
    Die Katalysator-Führungskraft fragt: "Was bräuchtet ihr, damit ihr gemeinsam zur Lösung kommt?" – und vernetzt dann beide Bereiche, weil sie das Muster sieht: Nicht fehlende Kompetenz ist das Problem, sondern fehlende Verbindung.
  </p>
</div>

<p class="mb-4">
  Wie in der Chemie beschleunigt eine katalytische Führungskraft Reaktionen im System, ohne sich dabei zu verbrauchen. Sie führt nicht durch Anweisung, sondern durch das Schaffen von Bedingungen: psychologische Sicherheit für Experimente, Vernetzung über Silos hinweg, Raum für Eigeninitiative. Sie ist der Brückenbauer auf der Meta-Ebene.
</p>

<h3 class="text-xl font-semibold mt-8 mb-4">Der messbare Business-Impact</h3>

<ul class="list-disc list-inside space-y-2 mb-6 text-joerg-700">
  <li>Schnellere Problemlösung durch interdisziplinäre Teams</li>
  <li>Höhere Innovation durch Wissenstransfer zwischen Bereichen</li>
  <li>Stärkere Resilienz durch verteilte statt zentralisierte Intelligenz</li>
  <li>Reduzierte Fluktuation durch sinnstiftende Arbeitsumgebungen</li>
</ul>
  `,
};
